<template>
	<div class="h-100">
		<div v-if="compact">
			<div class="pb-2">
				<h5>Engagement</h5>
			</div>

			<v-row :no-gutters="$vuetify.breakpoint.mdAndUp">
				<v-col cols="12" :md="!hideDeclines ? 6 : 12">
					<span class="grey--text text--darken-2 text-caption">
						Invitations Accepted
					</span>
					<v-divider class="mb-2 opacity-50"></v-divider>
					<span class="font-weight-bold text-caption">
						{{
							`${inviteHelpers.invitationStats(invite).accepted.total}/${invite
									.otherInvitees.length + 1}`
						}}
					</span>
				</v-col>
				<v-col v-if="!hideDeclines" class="text-md-right" cols="12" md="6">
					<span class="grey--text text--darken-2 text-caption">
						Invitations Declined
					</span>
					<v-divider class="mb-2 opacity-50"></v-divider>
					<span class="font-weight-bold text-caption">
						{{
							`${inviteHelpers.invitationStats(invite).declined.total}/${invite
									.otherInvitees.length + 1}`
						}} 
					</span>
				</v-col>
			</v-row>
		</div>

		<v-sheet
				v-else
				class="h-100 grey lighten-5"
				:class="$vuetify.breakpoint.smAndDown ? 'pa-4' : 'pa-8'"
				rounded="lg"
		>
			<h5 class="mt-n2">Progress</h5>
			<span class="grey--text text--darken-2 text-caption">
				Project Preparedness
			</span>
			<v-divider class="mb-2 opacity-50"></v-divider>
			<template v-if="inviteHelpers.projectLaunchProgress(invite) >= 0">
				<div class="d-flex justify-space-between mb-2 mt-4 text-subtitle-2">
					<div>Launch Day</div>
					<div>In {{ inviteHelpers.projectLaunchDaysRemaining(invite) }} days!</div>
				</div>
				<v-progress-linear
						color="info"
						rounded
						:value="inviteHelpers.projectLaunchProgress(invite)"
				></v-progress-linear>
			</template>
			<div class="d-flex justify-space-between mb-2 mt-6 text-subtitle-2">
				<div>Invitations Accepted</div>
				<div>{{ inviteHelpers.invitationStats(invite).accepted.total }}</div>
			</div>
			<v-progress-linear
					color="success"
					rounded
					:value="inviteHelpers.invitationStats(invite).accepted.percent"
			></v-progress-linear>
			<div class="d-flex justify-space-between mb-2 mt-6 text-subtitle-2">
				<div>Invitations Declined</div>
				<div>{{ inviteHelpers.invitationStats(invite).declined.total }}</div>
			</div>
			<v-progress-linear
					color="grey lighten-1"
					rounded
					:value="inviteHelpers.invitationStats(invite).declined.percent"
			></v-progress-linear>
		</v-sheet>
	</div>
</template>

<script>
import { inviteHelpers } from '../../helpers';

export default {
	name: 'ProjectProgress',
	props: {
		compact: {
			type: Boolean,
			default: false
		},
		hideDeclines: Boolean,
		invite: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			inviteHelpers
		};
	},
	computed: {
		invitesByStatus() {
			return this.campaignStatuses.reduce((acc, status) => {
				const campaigns = this.invites.filter(
						invite => status.code === `${status.assignment}_${invite.statusCode}`
				);
				const inviteStatusCode = status.code.replace(`${status.assignment}_`, '');
				return { ...acc, [inviteStatusCode]: campaigns };
			}, {});
		},
		campaignStatuses() {
			return this.statuses.filter(status => status.assignment === 'campaign_assignment');
		},
		productStatuses() {
			return this.statuses.filter(status => status.assignment === 'product');
		},
		venueStatuses() {
			return this.statuses.filter(status => status.assignment === 'venue');
		}
	},
	methods: {}
};
</script>
